import React from 'react'
import YouTube from 'react-youtube'

const YoutubeVideo =(props)=>{

    if (props.produkt===null) return null

    let player = null

    function setPlayer(e){
        player = e;
       // play()
    }

    function play(){
        if (player===null || player===null) return
        player.seekTo(props.produkt.video_ab_sec)
        player.playVideo() 
        if (props.produkt.video_dauer > 0)
        setTimeout(function(){    
            player.pauseVideo()
        },props.produkt.video_dauer * 1000)  
    }

    function pause(){
        player.pauseVideo()
    }

    function onReady(e){  
        setPlayer(e.target)      
    }

    let height = 326;
    let width = 580;
   /* if (props.karteikarte.nur_audio_abspielen===1){            
        height = 2
        width = 2
        className="hiddenplayer"
    }*/

        const end = props.produkt.video_ab_sec + props.produkt.video_dauer

    let opts = {
        height,
        width,
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 0,
            controls:0,
            start:props.produkt.video_ab_sec,
            end
        },
    }

     const url = `https://youtube.com/watch?v=${props.produkt.videourl}`

    return(          
        <div>     
            <div style={{textAlign:'center', position:'relative'}}>
                      
                <YouTube    
                    videoId={props.produkt.videourl}
                    key={props.produkt.id}   
                    onReady={(e)=>onReady(e)}  
                    opts={opts}  
                                      
                />
               
            </div> 
            <div style={{display:'flex'}}>
                <div className="btn btn-info btn-small" onClick={play}><i className="material-icons"> replay </i></div>
                <div className="btn btn-info btn-small" onClick={pause}><i className="material-icons"> pause </i></div>
            </div>
         </div>
    )
}

export default YoutubeVideo